export type RecurringRequest = {
    decisionId: number
    decisionNumber: string
    patientName: string
    patientNationalId: string
    hospitalId: number
    hospital: string
    monthlyAmount: number
    remainingAmount: number
    diagnosis: string
    serviceType: string
    isFakeDecision: boolean
    isRegisteredForDelivery: boolean
    deliveryDateThisMonth: string
    decisionTypeId: number
    decisionType: string
    decisionStartDate: string
    decisionEndDate: string
}

export type RecurringDecisionMedicine = {
    decisionMedicineId: number,
    medicineId: number,
    medicineName: string,
    amount: number,
    price: number,
    patientCostShare: number,
    availableStock: number,
    availableDonatedStock: number,
    duplicatePatientMedicine: DuplicatePatientMedicine
}

export type DuplicatePatientMedicine = {
    medicineId: number,
    decisionNumbers: string[],
    amount: number,
    maxMedicineAmount: number
}

export enum RequestDispensingType {
    Manual = 1,
    Delivery = 2,
}

export enum RequestType {
    Manual = 1,
    Delivery = 2,
}

type Medicine = {
    decisionMedicineId: number,
    isAvailable: boolean,
    fromDonationsStock: boolean,
}

export type SubmitRecurringRequestBody = {
    decisionId: number,
    pharmacyId: number,
    requestDispensingType: RequestDispensingType,
    medicines: Medicine[]
}